export const CalendarIcon: React.FC = () => {
	return (
		<svg
			fill="none"
			height="24"
			viewBox="0 0 24 24"
			width="24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4 8H20M4 8V16.8C4 17.92 4 18.48 4.218 18.908C4.40974 19.2843 4.71569 19.5903 5.092 19.782C5.519 20 6.079 20 7.197 20H16.803C17.921 20 18.48 20 18.907 19.782C19.284 19.59 19.59 19.284 19.782 18.908C20 18.48 20 17.922 20 16.804V8M4 8V7.2C4 6.08 4 5.52 4.218 5.092C4.41 4.715 4.715 4.41 5.092 4.218C5.52 4 6.08 4 7.2 4H8M20 8V7.197C20 6.079 20 5.519 19.782 5.092C19.59 4.71554 19.2837 4.40957 18.907 4.218C18.48 4 17.92 4 16.8 4H16M8 4H16M8 4V2M16 4V2"
				stroke="#212B36"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
			/>
		</svg>
	);
};
